import axios from '@/vendors/axios';

export default {
  item: {
    items() {
      return axios.get('/items');
    },
    search(params = {}) {
      return axios.post('/item/search', params);
    },
    get(id) {
      return axios.get(`/item/${id}`);
    },
  },
  monster: {
    monsters() {
      return axios.get('/monsters');
    },
    search(params = {}) {
      return axios.post('/monster/search', params);
    },
    get(id) {
      return axios.get(`/monster/${id}`);
    },
  },
  map: {
    maps() {
      return axios.get('/maps');
    },
  },
  skill: {
    skills() {
      return axios.get('/skills');
    },
  },
};
